
export enum ShortageTypeCd {
	ALL_SHORT = 'AllShort',
	PART_SHORT = 'PartShort'}

